// extracted by mini-css-extract-plugin
export var halfsies = "rating-module--halfsies--878ef";
export var insurerRatingOverview = "rating-module--insurerRatingOverview--e8a12";
export var ourReview = "rating-module--ourReview--1531b";
export var ratingItem = "rating-module--ratingItem--27c16";
export var ratingNumber = "rating-module--ratingNumber--edb42";
export var ratingStars = "rating-module--ratingStars--9af64";
export var ratingValue = "rating-module--ratingValue--4e6c5";